module.exports = __webpack_public_path__ + "static/img/notif_icon.f003709.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/notif_icon.png
// module id = /jaH
// module chunks = 1